module.exports = __webpack_public_path__ + "img/dice-4-active.79e9155c.png";